import { storable } from '$lib/utils/storable';

export const transcriptionStore = storable('transcriptions', {});
